import { NCDialect } from '@components/ncFileVersions/components/NCFileDiffView/types';

const KLARTEXT_EXTENSION_PATTERN = /\.h$/i;

// Heidenhain controls ship two file flavors. .H = Klartext (conversational),
// .I/.NC = ISO (G-code, the ISO 6983 / DIN 66025 standard). When the filename
// is missing or doesn't match a known Klartext extension, fall back to ISO —
// it is the international standard emitted by Fanuc, Siemens, Haas, Mazak,
// Okuma, Mitsubishi posts and is the dominant dialect across the global NC
// fleet. Klartext is essentially Heidenhain-only, so requiring the explicit
// .H signal keeps it from poisoning ISO files that arrive without extensions.
export const detectDialect = (fileName?: string | null): NCDialect =>
  fileName && KLARTEXT_EXTENSION_PATTERN.test(fileName) ? 'klartext' : 'iso';
